<template>
  <RevCard>
    <div class="flex items-center p-24">
      <div class="flex-1">
        <div class="heading-2"><slot name="title" /></div>
        <div class="body-1 mb-16"><slot name="subtitle" /></div>

        <div
          v-if="slots.info"
          class="bg-static-info-low rounded-sm inline-flex px-16 py-8"
        >
          <IconGrowth class="mr-12" />

          <div class="flex-col">
            <div class="body-1-bold">
              <slot name="info" />
            </div>
            <div>
              <slot
                v-if="slots['sub-info'] && shouldShowContent"
                name="sub-info"
              />
            </div>
          </div>
        </div>

        <div
          v-if="slots.success && !shouldShowContent"
          class="bg-static-success-mid rounded-sm inline-flex items-center px-16 py-8"
        >
          <IconSparkles class="mr-12" />
          <div class="body-1-bold"><slot name="success" /></div>
        </div>
      </div>

      <button v-if="slots.content" @click="showContent">
        <IconChevronDown v-if="!shouldShowContent" />
        <IconChevronUp v-if="shouldShowContent" />
      </button>
    </div>

    <div v-if="$slots.content && shouldShowContent">
      <slot name="content" />
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { type VNode, ref, watch } from 'vue'

import { RevCard } from '@ds/components/Card'
import { IconChevronDown } from '@ds/icons/IconChevronDown'
import { IconChevronUp } from '@ds/icons/IconChevronUp'
import { IconGrowth } from '@ds/icons/IconGrowth'
import { IconSparkles } from '@ds/icons/IconSparkles'

const slots = defineSlots<{
  title?(): VNode
  subtitle?(): VNode
  info?(): VNode
  'sub-info'?(): VNode
  success?(): VNode
  content?(): VNode
}>()

const shouldShowContent = ref(false)
const emit = defineEmits(['on-close', 'on-open'])

function showContent() {
  if (slots.content) {
    shouldShowContent.value = !shouldShowContent.value
  }
}

watch(shouldShowContent, () => {
  if (!shouldShowContent.value) {
    emit('on-close')
  } else {
    emit('on-open')
  }
})
</script>
